import React from 'react'
import { Autocomplete, Checkbox, FormControlLabel, TextField } from '@mui/material'

import {
  AUTOCOMPLETE_POPPER_SLOT_PROPS,
  STORE_RELATION_FORM_TEXT
} from '../constants/storeRelationFormConstants'

const StoreRelationPrincipalSection = ({
  isClientStepCompleted = false,
  principalSalesmanOptions = [],
  principalSalesmenLoading = false,
  principalUserOption = null,
  principalUserSearch = '',
  showValidationErrors = false,
  hasPendingPrincipalReassignment = false,
  canSplitOrderByBrand = false,
  shouldAssignUsersByBrand = false,
  onPrincipalUserChange,
  onPrincipalUserSearchChange,
  onToggleAssignUsersByBrand
}) => (
  <>
    <div className="store-relations-form__section">
      <h4 className="store-relations-form__section-title">{STORE_RELATION_FORM_TEXT.PRINCIPAL_SECTION_TITLE}</h4>
      <p className="store-relations-form__section-text">
        {STORE_RELATION_FORM_TEXT.PRINCIPAL_SECTION_TEXT}
      </p>

      <Autocomplete
        className="store-relations-form__autocomplete"
        fullWidth
        disabled={!isClientStepCompleted}
        slotProps={{ popper: AUTOCOMPLETE_POPPER_SLOT_PROPS }}
        options={principalSalesmanOptions}
        loading={principalSalesmenLoading}
        value={principalUserOption}
        inputValue={principalUserSearch}
        isOptionEqualToValue={(option, value) => option?.id === value?.id}
        getOptionLabel={(option) => option?.label || ''}
        onChange={(_, nextOption) => {
          onPrincipalUserChange(nextOption)
        }}
        onInputChange={(_, nextInputValue, reason) => {
          if (reason === 'reset') return

          onPrincipalUserSearchChange(nextInputValue)
        }}
        noOptionsText={STORE_RELATION_FORM_TEXT.NO_OPTIONS}
        loadingText={STORE_RELATION_FORM_TEXT.LOADING_USERS}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            required
            error={(showValidationErrors && !principalUserOption?.db_ref) || hasPendingPrincipalReassignment}
            helperText={hasPendingPrincipalReassignment
              ? STORE_RELATION_FORM_TEXT.PRINCIPAL_REASSIGN_REQUIRED
              : showValidationErrors && !principalUserOption?.db_ref
                ? STORE_RELATION_FORM_TEXT.PRINCIPAL_REQUIRED
                : ''}
            label={STORE_RELATION_FORM_TEXT.USER_SEARCH_LABEL}
          />
        )}
      />
    </div>

    {canSplitOrderByBrand && (
      <div className="store-relations-form__option">
        <p className="store-relations-form__option-title">
          {STORE_RELATION_FORM_TEXT.BRAND_ASSIGNMENT_OPTION_TITLE}
        </p>
        <p className="store-relations-form__section-text">
          {STORE_RELATION_FORM_TEXT.BRAND_ASSIGNMENT_OPTION_TEXT}
        </p>

        <FormControlLabel
          control={
            <Checkbox
              disableRipple
              checked={shouldAssignUsersByBrand}
              onChange={(event) => {
                onToggleAssignUsersByBrand(event.target.checked)
              }}
              sx={{
                '&:hover': {
                  backgroundColor: 'transparent'
                }
              }}
            />
          }
          label={STORE_RELATION_FORM_TEXT.BRAND_ASSIGNMENT_OPTION_LABEL}
        />
      </div>
    )}
  </>
)

export default StoreRelationPrincipalSection
